<template>
  <div
    class="notif-item"
    :class="{ 'notif-item--unread': !item.is_read, 'notif-item--compact': compact }"
    role="button"
    tabindex="0"
    @click="$emit('open', item)"
    @keydown.enter.prevent="$emit('open', item)"
  >
    <div class="notif-item__icon" :style="{ color: meta.color, backgroundColor: `${meta.color}14` }">
      <q-icon :name="meta.icon" :size="compact ? '18px' : '20px'" />
    </div>

    <div class="notif-item__body">
      <div class="notif-item__meta">
        <span class="notif-item__module">{{ meta.label }}</span>
        <span class="notif-item__sep">·</span>
        <span class="notif-item__time" :title="item.created_at_fmt">{{ timeLabel }}</span>
      </div>
      <div class="notif-item__title">{{ item.title }}</div>
      <div v-if="item.body" class="notif-item__text">{{ item.body }}</div>
    </div>

    <div class="notif-item__side">
      <span v-if="!item.is_read" class="notif-item__dot" aria-label="Не прочитано" />
      <q-btn
        v-if="!item.is_read"
        flat
        round
        dense
        size="sm"
        icon="done"
        color="grey-7"
        class="notif-item__read-btn"
        aria-label="Отметить прочитанным"
        @click.stop="$emit('mark-read', item)"
      >
        <q-tooltip>Отметить прочитанным</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { formatRelative, getModuleMeta } from "./constants";

export default {
  name: "NotificationItem",
  props: {
    item: { type: Object, required: true },
    compact: { type: Boolean, default: false },
  },
  emits: ["open", "mark-read"],
  computed: {
    meta() {
      return getModuleMeta(this.item.source_module);
    },
    timeLabel() {
      return formatRelative(this.item.created_at, this.item.created_at_fmt);
    },
  },
};
</script>

<style scoped lang="scss">
.notif-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  outline: none;

  &:hover,
  &:focus-visible {
    background: #f2f5f8;
  }

  &--unread {
    background: #f5f8ff;
  }

  &__icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--compact &__icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 16px;
    color: #6b7280;
    margin-bottom: 2px;
  }

  &__module {
    font-weight: 600;
  }

  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #111827;
  }

  &--unread &__title {
    font-weight: 700;
  }

  &__text {
    margin-top: 2px;
    font-size: 13px;
    line-height: 18px;
    color: #4b5563;
    word-break: break-word;
  }

  &--compact &__text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__side {
    flex-shrink: 0;
    width: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-top: 6px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #0060fe;
  }

  // Кнопка «прочитано» появляется при наведении; на тач-экранах видна всегда.
  &__read-btn {
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover &__read-btn,
  &:focus-within &__read-btn {
    opacity: 1;
  }

  @media (hover: none) {
    &__read-btn {
      opacity: 1;
    }
  }
}
</style>
